import { createSlice } from '@reduxjs/toolkit';
import { claimPackageRank, getRanking } from '../views/Ranking/Ranking.actions';
import { PackageRankMyProgressModel } from '../views/Ranking/Ranking.types';
import { redeemFlipmeCardInRank } from '../views/FlipMeWallet/FlipMeWallet.actions';

export interface RankingSliceType {
  loading: boolean;
  ranking: PackageRankMyProgressModel[];
  loadingRewards: boolean;
}

const initialState = {
  loading: false,
  ranking: [],
  loadingRewards: false
} as RankingSliceType;

const rankingSlice = createSlice({
  name: 'ranking',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(getRanking.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(getRanking.fulfilled, (state, { payload }) => {
      state.loading = false;
      if (payload) {
        state.ranking = payload;
      }
    });
    builder.addCase(getRanking.rejected, (state) => {
      state.loading = false;
    });

    builder.addCase(claimPackageRank.pending, (state) => {
      state.loadingRewards = true;
    });
    builder.addCase(claimPackageRank.fulfilled, (state, { payload }) => {
      state.loadingRewards = false;

      const index = state.ranking?.findIndex(
        (p) => p.packageRankId === payload
      );

      state.ranking[index].canClaimReward = false;
    });
    builder.addCase(claimPackageRank.rejected, (state) => {
      state.loadingRewards = false;
    });

    builder.addCase(redeemFlipmeCardInRank.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(redeemFlipmeCardInRank.fulfilled, (state, { payload }) => {
      state.loading = false;
    });
    builder.addCase(redeemFlipmeCardInRank.rejected, (state) => {
      state.loadingRewards = false;
    });
  }
});

export default rankingSlice.reducer;
